import Cookies from 'js-cookie';
import * as TagManagerUtils from '../tag-manager-utils';
import { getContact } from '@accor/customer-api/dist';
import { DEFAULT_USER_DATA } from './../constants'

export const pushUserData = async () => {
  try {
    return getUserData().then(userData => {
      return Promise.resolve(setUserData(userData));
    });
  } catch (error) {
    return Promise.reject(error);
  }
};


export const getUserData = async () => {
  let userData = null;
  try {
    const getContactImpl = await getContact();
    userData = await getContactImpl(
      {
        fields: 'individual.uaUserId,individual.isLoyaltyMember,contactMediums.contactMedium.postalAddress.city,contactMediums.contactMedium.emailContact.email,contactMediums.contactMedium.postalAddress.countryCode,loyalty.loyaltyCards.card.cardProduct.cardCodeTARS,loyalty.subscriptionCards.card.cardProduct.cardCodeTARS,loyalty.subscriptionCards.card.cardProduct.productLabel,loyalty.balances.nbPoints,individual.individualSubscriptions.individualSubscription,loyalty.awardTypes.allTypesAwardEligibility,loyalty.awardTypes.awardType.numberOfRemainingAwards,loyalty.awardTypes.numberOfRemainingAwards,loyalty.awardTypes.awardType.type,loyalty.freenights.freenight,loyalty.freenights.isEligible',
        filter: 'loyalty.loyaltyCards.card:isLastActiveCard=true;loyalty.subscriptionCards.card:isLastActiveCard=true;contactMediums.contactMedium.postalAddress:isPrimary=true;,contactMediums.contactMedium.emailContact:isPrimary=true;individual.individualSubscriptions.individualSubscription:optin=true;loyalty.freenights.freenight:status=REDEEMABLE;loyalty.awardTypes.awardType:type=SNU',
      }
    );
  } catch (error) {
    return userData;
  }
  return userData;
};

async function setUserData(userInfo) {
 
  if (userInfo) { 
    DEFAULT_USER_DATA['uilogged'] = true;

    /**
     * get user email if exist.
     * hash Email with SHA-256.
     * send it on the data layer user_data objet
     */
    // 
    const userEmail = userInfo?.contactMediums?.contactMedium?.find(medium => Object.prototype.hasOwnProperty.call(medium, 'emailContact'))?.emailContact?.email || '';
    if(userEmail  && userEmail !== '') {
      DEFAULT_USER_DATA['uiemailsha256'] = await TagManagerUtils.hashCode(userEmail);
    }
    
    DEFAULT_USER_DATA['userId'] = userInfo?.individual?.uaUserId;
  
    DEFAULT_USER_DATA['uicity'] = userInfo?.contactMediums?.contactMedium[0]?.postalAddress?.city || '';
    DEFAULT_USER_DATA['uicountry'] = userInfo?.contactMediums?.contactMedium[0]?.postalAddress?.countryCode || '';
  
    DEFAULT_USER_DATA['uiallmember'] = userInfo?.individual?.isLoyaltyMember ? 'yes' : 'no';
  
    const points = userInfo?.loyalty?.balances?.nbPoints;
    if (points >= 0 && points <= 2000) {
      DEFAULT_USER_DATA['uiloyaltypoints'] = '0 - 2000';
    } else if (points > 2000 && points <= 7000) {
      DEFAULT_USER_DATA['uiloyaltypoints'] = '2000 - 7000';
    } else if (points > 7000 && points <= 14000) {
      DEFAULT_USER_DATA['uiloyaltypoints'] = '7000 - 14000';
    } else if (points > 14000) {
      DEFAULT_USER_DATA['uiloyaltypoints'] = '14000+';
    }
  
    if (userInfo?.individual?.individualSubscriptions?.individualSubscription.length >= 1) {
      DEFAULT_USER_DATA['newsletteroptin'] = true;
    }
  
    const CardsLoyalty = [];
    const loyaltyCardProduct = userInfo?.loyalty?.loyaltyCards?.card[0]?.cardProduct || null; 
    
    if(loyaltyCardProduct && typeof loyaltyCardProduct?.cardCodeTARS !='undefined') {
      CardsLoyalty.push(loyaltyCardProduct?.cardCodeTARS)
    }

    const subscriptionCardProduct = userInfo?.loyalty?.subscriptionCards?.card[0]?.cardProduct || null;

    if(typeof subscriptionCardProduct?.cardCodeTARS !='undefined') {
      CardsLoyalty.push(subscriptionCardProduct?.cardCodeTARS)
    }
    
    DEFAULT_USER_DATA['loyaltycardtypes'] = CardsLoyalty.join(',');
  
    DEFAULT_USER_DATA['uistayplus_activation'] = 'no stay plus';
    DEFAULT_USER_DATA['uisnu_activation'] = 'no snu';
    
    let awardsCookie = Cookies.get('activeAwards') ? JSON.parse(Cookies.get('activeAwards')) :  null;
    if (userInfo?.loyalty?.awardTypes?.allTypesAwardEligibility === 'ELIGIBLE' && userInfo?.loyalty?.awardTypes?.awardType.length && userInfo?.loyalty?.awardTypes?.awardType[0]?.numberOfRemainingAwards > 0 && userInfo?.loyalty?.awardTypes?.awardType[0]?.type === 'SNU') {
      DEFAULT_USER_DATA['uisnu_activation'] = false
      if (awardsCookie && DEFAULT_USER_DATAect.keys(awardsCookie).length && awardsCookie['snu']) {
        DEFAULT_USER_DATA['uisnu_activation'] = true;
      }
    }
    
    if (userInfo?.loyalty?.freenights?.freenight.length > 0 && userInfo?.loyalty?.freenights?.isEligible) {
      DEFAULT_USER_DATA['uistayplus_activation'] = false
      if (awardsCookie && DEFAULT_USER_DATAect.keys(awardsCookie).length && awardsCookie['stayplus']) {
        DEFAULT_USER_DATA['uistayplus_activation'] = true;
      }
    }
    
    //Check B2B user from Get Contact basing on new card label value : ALL PLUS ibis & ALL PLUS Voyageur
    if(TagManagerUtils.isB2B(userInfo)) {
      DEFAULT_USER_DATA['clienttype'] = 'B2B';
    }

  }

  return DEFAULT_USER_DATA;
}